import { enqueueSnackbar } from "notistack";
import { ieqGptApi } from "../config";
import { LLMConfigurationDataType } from "../types";

export const getLLMConfiguration = () => {
    return ieqGptApi().get('/list-llms').then((response) => {
        return (response?.data?.data || []) as LLMConfigurationDataType[]
    }).catch((err) => {
        console.log(err, 'Error');
        return [] as LLMConfigurationDataType[];
    });
}
export const createLLMConfiguration = async (req: Partial<LLMConfigurationDataType>) => {
    try {
        if (!req?.id) delete req.id;
        const response = await ieqGptApi().post('/save-llm-details', req);
        if (response?.data?.status === "success") {
            enqueueSnackbar(response?.data?.data, { variant: 'success' });
            return true;
        } else {
            enqueueSnackbar("Unable to store LLM Configuration. please try again.", { variant: 'error' });
            return false;
        }
    } catch (err: any) {
        console.log(err, 'Error');
        if (err?.response?.data?.detail) {
            enqueueSnackbar(err?.response?.data?.detail, { variant: 'error' });
        } else {
            enqueueSnackbar("Unable to store LLM Configuration. please try again.", { variant: 'error' });
        }
        return false;
    }
}

export const deleteLLMConfiguration = async (id: string) => {
    return ieqGptApi().delete(`delete-llm-configuration/${id}`).then((response) => {
        if (response?.data?.status === "success") {
            enqueueSnackbar(response?.data?.data, { variant: 'success' });
            return true;
        } else {
            enqueueSnackbar(response?.data?.data, { variant: 'error' });
            return false;
        }
    }).catch((err) => {
        console.log(err, 'Error');
        if (err?.response?.data?.detail) {
            enqueueSnackbar(err?.response?.data?.detail, { variant: 'error' });
        } else {
            enqueueSnackbar("Failed to delete LLM Configuration. Please try again.", { variant: 'error' });
        }
        return false;
    });
}